import expandRange from './expandRange';

// if cursor is 'f|oo bar', expand to '|foo bar|'
export default function expandRangeToLine(range, value) {
  expandRange(range, value, /[\n]/);
}
